import { Device, until } from '@helpers/media';
import CarouselProvider from '@stories/Components/Misc/Carousel/CarouselProvider/CarouselProvider';
import Connected from '@stories/Components/Misc/Carousel/Connected/Connected';
import Controls from '@stories/Components/Misc/Carousel/Controls/Controls';
import SimpleTrack from '@stories/Components/Misc/Carousel/SimpleTrack/SimpleTrack';
import SectionHeader from '@stories/Components/SectionHeader/SectionHeader';
import SignpostCard from '@stories/Components/SignpostCard/SignpostCard';
import * as React from 'react';
import useMedia from 'react-use/esm/useMedia';
import S from './SignpostCardsSection.styles';
const SignpostCardsSection = ({ anchorId, cards, columnCount = 2, ...rest }) => {
    const imgSizes = `${until(Device.TabletSmall)} 100vw, ${until(Device.TabletLarge)} 50vw, ${columnCount === 3
        ? `${until(Device.Desktop)} 37.5vw, ${until(Device.DesktopLarge)} 25vw, 388px`
        : `${until(Device.DesktopLarge)} 37.5vw, 601px`}`;
    // Only want carousel behavior on mobile layout.
    const enableCarousel = useMedia(until(Device.TabletSmall), false);
    return (React.createElement(CarouselProvider, { count: cards.length },
        React.createElement(S.Container, { id: anchorId, "data-column-count": columnCount },
            React.createElement(SectionHeader, { ...rest }),
            React.createElement(S.CarouselWrapper, null,
                React.createElement(Connected, null, (carousel) => (React.createElement(SimpleTrack, { initCarousel: enableCarousel, mobileOnly: true }, cards.map((card, i) => (React.createElement(S.Item, { key: `signpost-card-${card.id}`, "data-active-item": carousel.activeIndex === i },
                    React.createElement(SignpostCard, { ...card, imgSizes: imgSizes })))))))),
            React.createElement(S.ControlsWrapper, null,
                React.createElement(Controls, { paginationTitle: "Signpost Cards Section carousel controls", wrap: false })))));
};
export default SignpostCardsSection;
